<template>
  <a
    v-if="data.url"
    :href="data.url"
    target="_blank"
    class="flex justify-center items-center cursor-pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 laptop:mt-0 rounded-full"
    rel="noopener noreferrer"
  >
    {{ data.title }} {{ data.version }}
    <div class="w-5 ms-2">
      <BaseIcon :name="data.icon" color="text-blue-700" />
    </div>
  </a>
  <div
    v-else-if="data.modalId"
    class="flex justify-center items-center pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 laptop:mt-0 rounded-full"
    @click="openModal"
  >
    <div class="font-bold text-sm flex justify-center items-center">
      <div class="me-2">{{ data.title }}</div>
      <div class="w-5">
        <BaseIcon :name="data.icon" color="text-blue-700" />
      </div>
    </div>
  </div>
  <div
    v-else
    class="flex justify-center items-center pointer bg-white w-full shadow-xl py-3 mx-3 mt-2 laptop:mt-0 rounded-full"
  >
    <div class="font-bold text-sm flex justify-center items-center">
      <div class="me-2">{{ data.title }}</div>
      <div class="w-5">
        <BaseIcon :name="data.icon" color="text-blue-700" />
      </div>
    </div>
  </div>
  <!-- <SectionModalIosInstall :isShow="isModalShowed" @close="closeModal" /> -->
</template>

<script setup>
defineProps({
  data: Object,
});

const isModalShowed = ref(false);

const openModal = () => {
  isModalShowed.value = true;
  document.body.style.overflow = "hidden";
};

const closeModal = () => {
  isModalShowed.value = false;
  document.body.style.removeProperty("overflow");
};
</script>
